// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.spinner-full-page-module__wrapper___X7_Fh {
  width: 100vw;
  height: 100vh;
  position: absolute;
  z-index: 1000;
}`, "",{"version":3,"sources":["data:;charset=utf-8,/**%20function%20to%20get%20dimensions%0A%20%20usage%20example%20to%20get%20%60tablet%60%20value%20from%20%60$page-max-widths%60%0A%20%20.class%20%7B%0A%20%20%20%20max-width:%20dim($page-max-widths,%20tablet);%0A%20%20%7D%0A%0A%20*/%0A%0A@use%20'sass:map';%0A%0A@function%20dim($prop,%20$key)%20%7B%0A%20%20@return%20map.get($prop,%20$key);%0A%7D%0A","webpack://./client/app/react-components/spinner-full-page/spinner-full-page.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;AAMF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `spinner-full-page-module__wrapper___X7_Fh`
};
export default ___CSS_LOADER_EXPORT___;
